/**
 *	@fileOverview Converts row number to string
 *	@param {number} row
 *
 *	@return {string}
 */
export default function(row: number): string
{
	return row.toString();
}